import { __awaiter, __generator } from "tslib";
import { deprecatedInlineSingleSelectKey } from './';
import { Simulate } from 'react-dom/test-utils';
export var createDeprecatedInlineSingleSelectDriver = function (wrapper) {
    var base = wrapper.$("." + deprecatedInlineSingleSelectKey);
    var maybeCustomView = base.$('.custom-view');
    var mouseDownOnElement = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var rawElem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, e.getNative()];
                case 1:
                    rawElem = _a.sent();
                    Simulate.mouseDown(rawElem);
                    return [2 /*return*/, Promise.resolve()];
                case 2: return [2 /*return*/, e.click()];
            }
        });
    }); };
    var focusSelect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var elem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(base.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, base.$('.Select-input').getNative()];
                case 1:
                    elem = _a.sent();
                    Simulate.focus(elem);
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, base.$('.Select-input').click()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var optionAtIndex = function (index) { return base.$$('.Select-option').get(index); };
    var openSelection = function () { return base.$('.Select-input input').click(); };
    return {
        getDisplayedText: function () { return base.text(); },
        openSelection: openSelection,
        openSelectionNoSearch: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusSelect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, base.$('.Select-input').click()];
                }
            });
        }); },
        isMenuOpen: function () { return base.$('.Select-menu-outer').exists(); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, optionAtIndex(index)];
                    case 1:
                        option = _a.sent();
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectOptionsBySelector: function (selector) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                option = base.$(selector);
                return [2 /*return*/, mouseDownOnElement(option)];
            });
        }); },
        selectAtIndexNoSearch: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$$('.Select-option').get(index).click()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, base.$$('.Select-option')
                        .map(function (e) { return e.text(); })];
            });
        }); },
        getSelectedValue: function () { return base.$('.Select-value').text(); },
        valueExists: function () { return base.$('.Select-value').exists(); },
        onHover: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView.exists()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').hover()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').hover()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        clickToEdit: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView.exists()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').click()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').click()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        showingSelect: function () { return base.$('.select-container').exists(); },
        clickClear: function () { return base.$('.clear-button').click(); },
        isClearDisabled: function () { return base.$('.clear-button.disabled').exists(); },
        clickConfirm: function () { return base.$('.confirm-button').click(); },
        clickCancel: function () { return base.$('.cancel-button').click(); },
        searchItems: function (searchTerm) { return base.$('input').enterValue(searchTerm); },
        getSearchInput: function () { return base.$('input').value(); },
        isRenderedValue: function () { return base.$('.inline-text-value').exists(); },
        isLoading: function () { return base.$('.tiny-loader').exists(); },
        isDisabled: function () { return base.$('.unfocused-body').hasClass('disabled'); },
        hasCancelConfirmButtons: function () { return base.$('.right-buttons').exists(); },
        getFocusedPlaceholer: function () { return base.$('.Select-placeholder').text(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map